import {
  Flex,
  Text,
  Checkbox,
  TextProps,
  FlexProps,
  SystemProps,
} from "@chakra-ui/react";
import React from "react";
import { useCurrentAccountStore } from "../../../../store/currentAccountStore";
import { useQueryAccountAssetOptions } from "../../../../store/useQueryAccountAssetOptions";
import { OrderFilterSetting } from "../../../../types/order/orderQuery";
import { HEADER_Z_INDEX } from "../../../atoms/StickyThead";
import { useSelectedTxContext } from "./SelectedTxContext";

export function MainTransactionsTableHeader({
  filters,
  top,
}: {
  filters: OrderFilterSetting;
  top: SystemProps["top"];
}) {
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);

  const queryAccountAssetOptions = useQueryAccountAssetOptions(accountId);

  const { selectionState, selectCurrentPage, clearAll } =
    useSelectedTxContext();

  const filteredBySingleAsset =
    filters.asset.length === 1 ?
      queryAccountAssetOptions.data?.find(
        (asset) => asset.value === filters.asset[0],
      )
    : undefined;

  return (
    <>
      <HeaderCell
        top={top}
        borderRightWidth="1px"
        borderLeftWidth="1px"
        left={0}
        zIndex={HEADER_Z_INDEX + 1}
      >
        <Checkbox
          size="lg"
          onChange={() => {
            if (selectionState === "none") {
              selectCurrentPage();
            } else {
              clearAll();
            }
          }}
          isIndeterminate={selectionState === "partialPage"}
          isChecked={
            selectionState === "allPages" || selectionState === "currentPage"
          }
          colorScheme="primary"
          justifyContent="center"
        />
      </HeaderCell>
      <HeaderCell top={top}>
        <HeaderText>Date</HeaderText>
      </HeaderCell>
      <HeaderCell top={top}>
        <HeaderText>Data Source</HeaderText>
      </HeaderCell>
      <HeaderCell top={top}>
        <HeaderText>Type</HeaderText>
      </HeaderCell>
      <HeaderCell top={top}>
        <HeaderText>Out</HeaderText>
      </HeaderCell>
      <HeaderCell top={top}>
        <HeaderText>In</HeaderText>
      </HeaderCell>
      {filteredBySingleAsset !== undefined && (
        <HeaderCell top={top}>
          <HeaderText>
            {filters.dataSource.length === 1 ?
              "Data Source Balance "
            : "Portfolio Balance "}
            ({filteredBySingleAsset.data.label})
          </HeaderText>
        </HeaderCell>
      )}
      <HeaderCell top={top} justifyContent="flex-end">
        <HeaderText>Outcome</HeaderText>
      </HeaderCell>
      <HeaderCell top={top} borderRightWidth="1px">
        <HeaderText>Hint</HeaderText>
      </HeaderCell>
    </>
  );
}

function HeaderCell(props: FlexProps): React.ReactElement {
  return (
    <Flex
      position="sticky"
      zIndex={HEADER_Z_INDEX}
      backgroundColor="white"
      px={3}
      py={2}
      minW={0}
      align="center"
      borderBottomWidth="1px"
      borderTopWidth="1px"
      borderColor="gray.300"
      {...props}
    />
  );
}

function HeaderText(props: TextProps): React.ReactElement {
  return <Text fontSize="sm" fontWeight="semibold" {...props} />;
}
